export default {
  name: 'status',
  components: {},
  props: ['status', 'options', 'caret'],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
    this.$emit('update:status', this.status)
    // this.stt = this.status
  },
  methods: {
    color (status) {
      if (this.caret) {
        return 'link'
      } else {
        switch (parseInt(status.code)) {
          case 0:
            return 'warning'
          case 1:
            return 'success'
          case 2:
            return 'danger'
          case 3:
            return 'primary'
          case 4:
            return 'info'
          case 5:
            return 'danger'
          default:
            return 'warning'
        }
      }
    },
    changeStatus (key) {
      switch (parseInt(key)) {
        case 1:
          this.$emit('approval')
          break
        case 2:
          this.$emit('rejection')
          break
        case 5:
          this.$emit('close')
          break
        case 4:
          this.$emit('corrective')
          break
        case 3:
          this.$emit('inProgress')
          break
        default:
          this.$emit('approval')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/status/status.js